import FormErrors from "@/components/FormErrors/FormErrors";
import HmAutocompleteObject from "@/components/Autocomplete/AutocompleteObject.vue";
import uuidv4 from "uuid/v4";
import { JSConn } from "@/utilities/js-conn";
import VueScrollTo from "vue-scrollto";
import { last as Rlast } from "ramda";

const SORT_ORDER_STEP_SIZE = 200;

export default {
  name: "templateWorkOrderTaskLineItemEditForm",
  components: {
    FormErrors,
    HmAutocompleteObject,
  },
  props: {
    taskId: String,
    lineItemId: String,
  },
  data() {
    return {
      hasLineItemErrors: false,
      lineItemErrors: [],
      lineItem: {
        id: null,
        template_work_order_task_id: "",
        line_item_id: "",
        line_item: {},
        sort_order: 200,
      },
    };
  },
  created() {
    this.$nextTick(() => {
      VueScrollTo.scrollTo("#top-target");
    });
  },
  computed: {
    lineItemsForAutocomplete: function() {
      return this.$store.getters.lineItemsForAutocomplete;
    },
    templateWorkOrderTaskById: function() {
      return id => this.$store.getters.templateWorkOrderTaskById(id);
    },
  },
  methods: {
    submitLineItemForm(evt) {
      evt.preventDefault();

      // get the last item in the list of line items
      const lastLineItem = Rlast(
        this.templateWorkOrderTaskById(this.taskId)
          .template_work_order_task_line_items,
      );

      let newSortOrderValue;
      if (lastLineItem) {
        newSortOrderValue = lastLineItem.sort_order + SORT_ORDER_STEP_SIZE;
      } else {
        newSortOrderValue = SORT_ORDER_STEP_SIZE;
      }
      this.lineItem.sort_order = newSortOrderValue;

      const jsConn = new JSConn();

      jsConn.formParams = {
        id: uuidv4(),
        template_work_order_task_id: this.taskId,
        line_item_id: this.lineItem.line_item_id,
        sort_order: this.lineItem.sort_order,
      };

      this.$store
        .dispatch("createTemplateWorkOrderTaskLineItem", jsConn)
        .then(() => {
          return Promise.resolve();
        })
        .catch(jsConn => {
          this.hasLineItemErrors = true;
          this.lineItemErrors = jsConn.error["response"]["data"];
          return Promise.resolve(jsConn);
        })
        .finally(() => {
          this.$emit("templateTasksChanged");
          this.$router.push({
            name: "templateWorkOrderTasks",
          });
        });
    },
    updateLineItem(evt) {
      this.lineItem.line_item = evt;
      this.lineItem.line_item_id = evt.value;
    },
  },
};
